module.exports = __webpack_public_path__ + "static/media/05.f9d28b16.jpg";